const SLATE_ID_COOKIE_KEY = "sc-slate-id";
const SLATE_ID_MAX_AGE_SECONDS = 24 * 60 * 60;

// Stored as a cookie rather than session storage so it travels with the
// document request: the istio VirtualService in front of app-tools-support
// reads sc-slate-id to decide which slate's build to serve, and that happens
// before any JavaScript runs.
export const getSlateId = (): string | null => {
  const prefix = `${SLATE_ID_COOKIE_KEY}=`;
  const entry = document.cookie
    .split(";")
    .map((part) => part.trim())
    .find((part) => part.startsWith(prefix));

  if (!entry) {
    return null;
  }

  try {
    return decodeURIComponent(entry.slice(prefix.length)) || null;
  } catch {
    // The cookie is routinely hand-edited, and a malformed percent-escape
    // makes decodeURIComponent throw. This runs on every gRPC call via the
    // interceptor, so fall back to no slate rather than breaking the app.
    return null;
  }
};

export const setSlateId = (value: string): void => {
  document.cookie = `${SLATE_ID_COOKIE_KEY}=${encodeURIComponent(value)}; path=/; max-age=${SLATE_ID_MAX_AGE_SECONDS}; samesite=strict`;
};

export const clearSlateId = (): void => {
  document.cookie = `${SLATE_ID_COOKIE_KEY}=; path=/; max-age=0; samesite=strict`;
};
